<template>
  <!-- 底部信息 -->
  <div class="foot-box">
    <div class="g-wrap">
      <div class="logo">
        <img src="@/assets/images/logo_small.png" alt="">
      </div>
      <div class="middle-info">
        <span>主办单位：江苏省总工会</span>
<!--        <span>网站访问量 27197681</span>-->
      </div>
      <div class="right-item"><span>联系我们</span><i class="line"></i><span>网站申明</span></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FooterInfo',
};
</script>
<style scoped>
.foot-box {
  height: 105px;
  display: flex;
  background: #f1f2f3;
  align-items: center;
  border-top: 1px solid #dadcde;
  font-size: 16px;
}
.foot-box .g-wrap{
  display: flex;
  align-items: center;
}
.middle-info{
  color: #666;
  margin-left: 20px;
  flex: 1;
}
.right-item .line{
  display: inline-block;
  width: 1px;
  height: 18px;
  background: #5b5b5b;
  margin: 0 28px;
}
</style>
